import React from 'react';

const Waves = props => {
    return (
        <div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 43.81">
                <path
                    d="M0,30.28s122.88-6.47,163.69-6.47,221.35,5.73,273.04,6.47c51.69.74,171.28-10.62,218.61-10.62s125.07,4.15,170.87,4.6c38.4.38,85.45-3.1,123.05-3.1s74.74,9.13,74.74,9.13v13.53H0v-13.53Z"
                    fill="#eff2ed"
                />
                <path
                    d="M1024,14.76v4.86s-37.14-9.13-74.74-9.13-84.65,3.48-123.05,3.1c-45.8-.45-123.54-4.6-170.87-4.6s-166.92,11.37-218.61,10.63c-51.69-.75-232.24-6.48-273.04-6.48S0,19.62,0,19.62v-3.77S140.49,6.9,181.3,6.9s234.22,8.52,285.91,9.27c51.69.74,140.8-16.16,188.13-16.16s142.5,9.37,188.31,9.83c38.39.37,69.82-4.4,107.42-4.4s72.93,9.34,72.93,9.34Z"
                    fill="#eff2ed"
                />
            </svg>
        </div>
    );
};

export default Waves;
